__turbopack_context__.v({
  "tabLabelText": "QuickSearchTabLabel-module__jzGl5W__tabLabelText",
  "tabLabelTextActive": "QuickSearchTabLabel-module__jzGl5W__tabLabelTextActive",
});
